export default __webpack_public_path__ + "static/icon-banner-c8156c6f99d46aea433fbbb651fd29dc.png";